class SampleRate {

  static id = 0x14;

  static type = 'SampleRate';
}

export default SampleRate;
